import React, { useState, useEffect, ChangeEvent, FormEvent } from "react";
//import Dashboard, { IOverview } from "../../../services/api/Dashboard";
import Year, { IYear } from "../../../services/api/Year";
import Month, { IMonth } from "../../../services/api/Month";
import Select from "../../../components/Form/Select";
import Input from "../../../components/Form/Input";
import Button from "../../../components/Form/Button";
import Loading from "../../../components/Loading";
import SendingFile from "./SendingFile";
import "../assets/css/inputFile.css";
import { SimpleResponse } from "../../../services/api/Request";
import System from "../../../services/api/System";
import Modal, { ModalTypes, SetModal } from "../../../components/Modal";

const ForecastImport: React.FC = () => {
  const [loading, isLoading] = useState<Boolean>(true);
  const [years, setYears] = useState<IYear[]>([]);
    const [months, setMonths] = useState<IMonth[]>([]);
    const [response, setResponse] = useState<SimpleResponse>();
    const [fileOK, setFileOK] = useState<boolean>(false);
    const [message, setMessage] = useState<string>('');
    const [year, setYear] = useState<number>(0);
    const [month, setMonth] = useState<number>(0);
    const [downloading, setDownloading] = useState<string>('');
    const [downloadError, setDownloadError] = useState<string>('');
    const date = new Date();

    const FileChecker = {
        checkMimeType: (event: ChangeEvent<HTMLInputElement>) => {
            const files: FileList = event.target.files!;
            const types: string[] = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];
            let err: string = "";

            for (let x = 0; files && x < files.length; x++) {
                console.log(files[x]);
                if (types.every((type) => files.item(x)!.type !== type))
                    err += files[x].type + " is not a supported format\n";
            }

            if (err !== "") {
                event.target.nodeValue = null;
                console.log(err);
                setMessage(err);
                return false;
            }
            return true;
        },
        maxSelectFile: (event: ChangeEvent<HTMLInputElement>) => {
            const files: FileList = event.target.files!;
            if (files.length > 1) {
                const msg = "Only 1 image can be uploaded at a time";
                event.target.nodeValue = null;
                console.log(msg);
                setMessage(msg);
                return false;
            }
            return true;
        },
        checkFileSize: (event: ChangeEvent<HTMLInputElement>) => {
            const files: FileList = event.target.files!;
            let size = 15000000; // 1.5MB
            let err = "";
            for (var x = 0; x < files.length; x++) {
                if (files[x].size > size)
                    err += files[x].type + " is too large, please pick a smaller file\n";
            }
            if (err !== "") {
                event.target.nodeValue = null;
                console.log(err);
                setMessage(err);
                return false;
            }
            return true;
        }
    };

    async function handleFormSubmit(event: FormEvent) {
        event.preventDefault();
        if (fileOK) {
            const formData: FormData = new FormData(event.target as HTMLFormElement);
            const response: SimpleResponse = await System.ImportForecast(formData);
            setResponse(response);
        }
    }

    async function handleDownload(download: () => Promise<void>, type: string) {
        setDownloadError('');
        setDownloading(type);

        try {
            await download();
        } catch (error: any) {
            if (error.message !== 'Unauthorized')
                setDownloadError(error.message || 'Download failed.');
        } finally {
            setDownloading('');
        }
    }

  useEffect(() => {
    isLoading(true);
    Promise.all([Year.GetAll(), Month.GetAll()])
      .then((value) => {
        const years = value[0].filter((value) => { return value.active });
        setYears(years);
        setMonths(value[1]);

        setYear(years[0].name);
        setMonth(date.getMonth() + 1);
        
        isLoading(false);
      })
      .catch(console.log);
  }, []);

    function handleChange(event: ChangeEvent<HTMLInputElement>) {
      let fileName = document.querySelector(".customInputFile .form-label")!;
      var files: FileList = event.target.files!;
        if (
            FileChecker.maxSelectFile(event) &&
            FileChecker.checkFileSize(event) &&
            FileChecker.checkMimeType(event)
        ) {
            fileName.textContent = "File ready to upload";
            setFileOK(true);
            //var f = files[0];
        } else {
            fileName.textContent = "File not suported";
            setFileOK(false);
		}
    //if (fileName != null) fileName.textContent = "File ready to upload";
    }

  return (
    <React.Fragment>
      {loading ? (
        <Loading />
      ) : (
        <React.Fragment>
            {response ? SetModal.FromResponse(response, () => {
                setResponse(undefined);
                if (response.status === 200) {
                    setMessage('');
                    let fileName = document.querySelector(".customInputFile .form-label")!;
                    fileName.textContent = "Import file";
                }
            }) : null}
            {downloadError ? <Modal
                title="Error"
                message={downloadError}
                type={ModalTypes.Error}
                onClose={() => setDownloadError('')}
            /> : null}
          <section className="content__block">
          <form className="form" onSubmit={handleFormSubmit}>
            <div className="content__header">
              <h2 className="content__title">Import Forecast</h2>

              <div className="multi-selects">
                <div className="content__select">
                  <Select
                    className="select-custom select-custom--medium select-custom--shadow"
                    name="month"
                    title="Month"
                    options={months.map((obj) => {
                      return { value: obj.id, label: obj.name };
                    })}
                        value={month}
                    handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
                      setMonth(+event.currentTarget.value);
                    }}
                  />
                </div>
                <div className="content__select">
                  <Select
                    className="select-custom select-custom--medium select-custom--shadow"
                    name="year"
                    title="Year"
                    options={years.map((obj) => {
                      return { value: obj.name, label: obj.name };
                    })}
                        value={year}
                    handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
                      setYear(+event.currentTarget.value);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="customInputFile">
              <Input
                name="ImportFile"
                type="file"
                title="Import file"
                handleChange={handleChange}
              />
               {message ? <span> {message}<br /> </span> : null}
              <Button
                className="button button--blue button--icon button--save"
                title="Send"
              />
            </div>
            <button
                type="button"
                className="button button--blue button--download"
                disabled={downloading !== ''}
                onClick={() => handleDownload(System.DownloadForecastModel, 'model')}>
                    {downloading === 'model' ? 'Downloading...' : 'Template download'}
            </button>
          </form>
          <div>
            <h2 className="content__title">Export Forecast</h2>
            <button
                type="button"
                className="button button--blue button--export"
                disabled={downloading !== ''}
                onClick={() => handleDownload(() => System.ExportForecast(year, month), 'export')}>
                    {downloading === 'export' ? 'Downloading...' : 'Export'}
            </button>
          </div>
          </section>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default ForecastImport;
